import { CircleDot, Music2, ShieldCheck } from 'lucide-react';

const principles = [
  {
    icon: Music2,
    title: 'The orchestra',
    subtitle: 'Technology executes.',
    text: 'Algorithms, models and systems provide power, reach and precision.',
  },
  {
    icon: CircleDot,
    title: 'The conductor',
    subtitle: 'Humanity directs.',
    text: 'People determine purpose, context, meaning and final decision-making.',
  },
  {
    icon: ShieldCheck,
    title: 'The score',
    subtitle: 'Governance preserves.',
    text: 'Ethics, restraint and accountability shape the conditions of responsible use.',
  },
];

export default function Principles() {
  return (
    <section className="principles section" id="principles">
      <div className="container">
        <div className="principles__header reveal">
          <div>
            <span className="eyebrow"><i /> The principles of orchestration</span>
            <h2>Build systems that amplify human intelligence without replacing human purpose.</h2>
          </div>
          <p>Symphonia is not a rejection of technology. It is a restoration of hierarchy.</p>
        </div>

        <div className="principles__grid reveal">
          {principles.map(({ icon: Icon, title, subtitle, text }, index) => (
            <article key={title}>
              <div className="principles__topline"><span>0{index + 1}</span><Icon size={24} strokeWidth={1.5} /></div>
              <h3>{title}</h3>
              <strong>{subtitle}</strong>
              <p>{text}</p>
            </article>
          ))}
        </div>

        <div className="closing-quote reveal">
          <span>Symphonia</span>
          <p>The future does not belong to the machine. It belongs to those who restore intelligence as purpose.</p>
        </div>
      </div>
    </section>
  );
}
